import { ApolloError, useQuery, NetworkStatus } from "@apollo/client";
import { GET_PROJECT_RUN_HISTORY } from "graphql/queries";
import { ProjectRun, ProjectStatus } from "types";

//todo: add a limit on how many documents are returned based on the date.
export function useProjectHistory(
    projectId?: String,
    showRunning: boolean = false
): [Array<ProjectRun>, boolean, ApolloError | undefined, any] {
    const { data, error, loading, refetch, networkStatus } = useQuery(GET_PROJECT_RUN_HISTORY, {
        variables: { projectId: projectId, showRunning: showRunning },
        fetchPolicy: "cache-and-network",
        notifyOnNetworkStatusChange: true,
        errorPolicy: "all",
        skip: !projectId
    });
    let res: Array<ProjectRun> = [];
    // todo: clean this up
    if (data && data.getRunHistory && networkStatus === NetworkStatus.ready) {
        const tmp = data.getRunHistory.slice();

        res = tmp.map((ard: any) => {
            const obj: ProjectRun = {
                id: ard.id,
                companyName: ard.companyName,
                lastUpdatedOn: ard.lastUpdatedOn,
                createdOn: ard.createdOn,
                user: ard.user,
                error: ard.error,
                outputs: ard.outputs,
                results: ard.results,
                status: ProjectStatus[ard.state] ? ProjectStatus[ard.state] : "Invalid State"
            };
            return obj;
        });
    }

    return [res, loading, error, refetch];
}
